<template>
  <div>
    <section class="plansInfoContainer">
      <section>
        <p>{{ this.$t('basePlan') }}:</p>
        <span>{{ planBase }}</span>
      </section>
      <section>
        <p>{{ this.$t('activePlan') }}:</p>
        <span>{{ planActive }}</span>
      </section>
    </section>

    <download-excel name="Dados da Premissas de Planejamento" :fetch="GerarExcel">
      <img class="ml-3 printer-button" src="@/assets/excel.png" :title="$t('gerar-relatorio')" :alt="$t('imprimir')" />
      <span v-if="loadingReport" class="spinner-border spinner-border-sm spinnerConfig" role="status"
        aria-hidden="true"></span>
    </download-excel>

    <b-overlay :show="waiting" variant="white" opacity="0.85" blur="50px">
      <div class="gridContent">
        <div class="sample1 grid middle"></div>

        <section class="inputsGroupContainer">
          <section class="generalInputs">
            <div>
              <p>{{ $t('ultima-revisao') }}</p>
              <span>{{ json.revision | dateBR }}</span>
            </div>

            <div>
              <label for="jsonBaseYear">{{ $t('ano-base') }}</label>
              <b-form-spinbutton class="spinbutton-pentagro" id="jsonBaseYear" v-model="json.baseYear"
                :disabled="searchingYearPlan" :min="(new Date().getFullYear() - 15).toString()"
                :max="(new Date().getFullYear() + 15).toString()" step="1">
              </b-form-spinbutton>
            </div>

            <div>
              <label for="jsonDescription">{{ $t('descricao') }}</label>
              <b-input class="spinbutton-pentagro" id="jsonDescription" v-model="json.description">
              </b-input>
            </div>

            <div class="dateSelectors">
              <section>
                <p>{{ $t('data-inicial') }}</p>
                <date-picker id="date-picker" ref="datePickerStart" name="date" v-model="json.initialDate"
                  :config="optionsDatePicker"></date-picker>
              </section>

              <section>
                <p>{{ $t('data-final') }}</p>
                <date-picker id="date-picker" ref="datePickerEnd" name="date" v-model="json.finalDate"
                  :config="optionsDatePicker"></date-picker>
              </section>

              <section>
                <p class="label-start-week">{{ $t('inicio-semana') }}</p>
                <b-form-select id="select-start-week" v-model="json.beginWeek" :options="options"></b-form-select>
              </section>
            </div>

            <div class="gridBtGroup">
              <img id="replanejarPlanoSafra" src="@/assets/replaned.png" :title="$t('replanejar-plano-de-safra')"
                :alt="$t('replanejar-plano-de-safra')"
                @click="() => { this.$bvModal.show('replanedProductionPlan') }" />
              <img src="@/assets/reviews.png" :alt="$t('revisoes-de-planejamento')"
                :title="$t('revisoes-de-planejamento')" @click="() => this.$bvModal.show('viewReviewsPlan')" />
              <span :class="!checkIsBase() ? '' : 'disable-btn'" id="playSimulation">
                <img src="@/assets/salvar.png" alt="salvar" :title="$t('salvar')" @click="saveHarvestPlan($event)" />
                <img src="@/assets/cancel.png" alt="cancelar" :title="$t('cancelar')"
                  @click="$bvModal.show('confirmPlanRestore')" />
              </span>
            </div>
          </section>

          <section class="planInputs">
            <button @click="openModal('base')">{{ this.$t('setBasePlan') }}</button>
            <button @click="openModal('active')">{{ this.$t('setActivePlan') }}</button>
          </section>
        </section>

        <b-modal id="replanedProductionPlan" size="md" hide-footer :title="'Criar Nova Revisão'"
          :no-close-on-backdrop="true">
          <createNewProductionPlanReplaned :planReplaned="replanedHarvestPlan"
            @updateHarvestPlan="planCreated = $event" />
        </b-modal>

        <b-modal id="confirmPlanRestore" ok-variant="danger" :ok-title="$t('yes')" :cancel-title="$t('no')" @ok="reset">
          Confirma o descarte das alterações?
        </b-modal>

        <b-modal id="viewReviewsPlan" :title="$t('revisoes-de-planejamento')" size="lg" hide-footer
          :no-close-on-backdrop="true">
          <ModalReviewsPlans :plans="plans" @view-plan="plan = $event" />
        </b-modal>

        <b-modal id="confirmPasswordModal" v-model="isModalVisible" title="Confirme a Senha" size="md" hide-footer
          :no-close-on-backdrop="true">
          <div>
            <b-form-group label="Senha" label-for="password-input">
              <b-form-input id="password-input" v-model="password" type="password"
                placeholder="Digite a senha"></b-form-input>
            </b-form-group>
            <div class="button-group">
              <b-button class="btn button-cancel" @click="isModalVisible = false">Cancelar</b-button>
              <b-button class="btn button-confirm" @click="confirmAction">Confirmar</b-button>
            </div>
          </div>
        </b-modal>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import * as cGridAll from "vue-cheetah-grid";
import * as cheetahGrid from "cheetah-grid";
import { urlMainAPI, defaultSuccess, showError } from "@/global";
import { mapState } from "vuex";
import axios from "axios";
import * as moment from "moment";

import createNewProductionPlanReplaned from "../productionPlanCreator/CreateNewProductionPlanReplaned.vue"
import ModalReviewsPlans from "./ModalReviewsPlans.vue";

export default {
  name: "HarvestPlanGrid",
  components: {
    ...cGridAll,
    ModalReviewsPlans,
    createNewProductionPlanReplaned
  },
  computed: mapState(["msg"]),
  watch: {
    async "json.baseYear"(value) {
      if (this.canSearch) {
        this.searchingYearPlan = true;
        await this.loadHarvestPlan(0, value, true);
        this.searchingYearPlan = false;

      }
      this.canSearch = true;
    },

    async plan(value) {
      this.canSearch = false;
      await this.loadHarvestPlan(value.id, 0, true);
      this.versionNumber = value.planData.versionNumber
    },

    async planCreated() {
      await this.loadHarvestPlans();
      await this.loadHarvestPlan();
    }
  },
  data: function () {
    return {
      loadingReport: false,
      planReplaned: {},
      canSearch: true,
      waiting: false,
      searchingYearPlan: false,
      plans: [],
      temp: [],
      json: {
        baseYear: new Date().getFullYear(),
        initialDate: moment().add(-365, "days").format("DD/MM/YYYY"),
        finalDate: moment().format("DD/MM/YYYY"),
        beginWeek: 1,
        revision: "",
        header: [],
        table: [],
      },
      options: [
        { value: 0, text: this.$t('selecione-o-inicio-da-semana'), disabled: true },
        { value: 1, text: this.$t('segunda-feira') },
        { value: 2, text: this.$t('terca-feira') },
        { value: 3, text: this.$t('quarta-feira') },
        { value: 4, text: this.$t('quinta-feira') },
        { value: 5, text: this.$t('sexta-feira') },
        { value: 6, text: this.$t('sabado') },
        { value: 7, text: this.$t('domingo') }
      ],
      optionsDatePicker: {
        locale: moment.locale("pt-br"),
        format: "DD/MM/YYYY",
        extraFormats: ["DD/MM/YYYY HH:mm:ss", "YYYY/MM/DD HH:mm:ss", "x"],
        dayViewHeaderFormat: "MMMM/YYYY",
        allowInputToggle: true,
        useCurrent: false,
        showTodayButton: true,
        showClear: true,
        showClose: true,
        sideBySide: false,
        inline: false,
        keepOpen: false,
        tooltips: {
          today: this.$t('hoje'),
          clear: this.$t('limpar'),
          close: this.$t('fechar'),
          selectMonth: this.$t('selecionar-mes'),
          prevMonth: this.$t('mes-anterior'),
          nextMonth: this.$t('proximo-mes'),
          selectYear: this.$t('selecionar-ano'),
          prevYear: this.$t('ano-anterior'),
          nextYear: this.$t('proximo-ano'),
          selectDecade: this.$t('selecionar-decada'),
          prevDecade: this.$t('decada-anterior'),
          nextDecade: this.$t('proxima-decada'),
          prevCentury: this.$t('seculo-anterior'),
          nextCentury: this.$t('proximo-seculo'),
        },
      },
      planActive: "",
      planBase: "",
      plan: 0,
      planCreated: {},
      versionNumber: "",
      isModalVisible: false,
      password: '',
      actionType: '',
      isBase: false,
      isActive: false
    };
  },
  filters: {
    dateBR(date) {
      let dateBr = Date.parse(date);
      dateBr = new Date(dateBr);
      dateBr = dateBr.toLocaleString("pt-BR");
      dateBr = dateBr.split(", ")[0];
      if (dateBr == "Invalid Date") {
        return "Aguardando dados ...";
      } else {
        return dateBr.replace(",", "");
      }
    },
  },
  methods: {
    checkIsBase() {
      return this.json.isBase
    },

    replanedHarvestPlan() {
      if (this.json) {
        let planReplaned = {
          planId: this.json.id,
          baseYear: this.json.baseYear,
          periodId: 0,
          description: "",
          revision: this.plan == 0 ? this.versionNumber : this.plan.planData.versionNumber,
          table: this.json.table,
          table2: []
        }
        return planReplaned
      }
    },

    async loadHarvestPlans() {
      this.waiting = true;
      const url = `${urlMainAPI}/getproductionharvestplans`
      await axios
        .get(url)
        .then((res) => { this.plans = res.data })
        .catch();
      this.waiting = false;
    },

    async loadHarvestPlan(id = 0, year = this.json.baseYear, isActive = true) {
      this.waiting = true;
      const url = `${urlMainAPI}/getproductionharvestplan/${id}/${year}/${isActive}/false`
      await axios
        .get(url)
        .then((res) => {
          this.json = res.data;

          if (!this.json.initialDate || !this.json.finalDate) {
            this.json.initialDate = moment().add(-365, "days").format("DD/MM/YYYY");
            this.json.finalDate = moment().format("DD/MM/YYYY")
          } else {
            this.json.initialDate = moment(this.json.initialDate);
            this.json.finalDate = moment(this.json.finalDate);
          }

          this.temp = JSON.parse(JSON.stringify(this.json));
          let canSplit = this.json.planActiveTxt != "Não existe plano para esse ano.";
          this.planActive = canSplit ? this.json.planActiveTxt.split('|')[0] : this.json.planActiveTxt
          this.planBase = canSplit ? this.json.planBaseTxt.split('|')[0] : this.json.planBaseTxt
          this.versionNumber = canSplit ? parseInt(this.json.planActiveTxt.split('|')[1].trim()) : 0
          this.setGrid();
          defaultSuccess(this.$t('dados-carregados'))
        })
        .catch();
      this.waiting = false;
    },

    updateZero1e6(array) {
      array.table.forEach((a) => {
        Object.keys(a).forEach((item) => {
          if (a[item]) {
            if (parseFloat(a[item].replace(/\./g, "").replace(/,/, ".")) == 0) {
              a[item] = "0,000001";
            }
          }
        });
      });
    },

    saveHarvestPlan: async function () {
      if (!this.json.beginWeek) {
        this.$bvToast.toast(this.$t('por-favor-selecione-o-dia-do-inicio-da-semana'), {
          title: "Campo dia da semana vazio...",
          variant: "warning",
          toaster: 'b-toaster-bottom-left',
          solid: true
        })
        return;
      }

      if (!this.json.description) {
        this.$bvToast.toast(this.$t('por-favor-informe-o-nome-do-plano'), {
          title: "Campo descrição vazio...",
          variant: "warning",
          toaster: 'b-toaster-bottom-left',
          solid: true
        })
        return;
      }

      this.updateZero1e6(this.json);

      let t1 = moment(this.json.initialDate, [
        "DD/MM/YYYY",
        "YYYY-MM-DD",
      ]).clone();
      let t2 = moment(this.json.finalDate, [
        "DD/MM/YYYY",
        "YYYY-MM-DD",
      ]).clone();
      t1 = t1.format("YYYY-MM-DD");
      t2 = t2.format("YYYY-MM-DD");

      if (t1 === "Data inválida") {
        showError(this.$t('por-favor-ajuste-a-data-inicial'));
        return;
      }
      if (t2 === "Data inválida") {
        showError(this.$t('por-favor-ajuste-a-data-final'));
        return;
      }


      let t1Compare = new Date(t1).getTime();
      let t2Compare = new Date(t2).getTime();

      if (t1Compare > t2Compare) {
        showError(this.$t('a-data-inicial-deve-ser-anterior-a-data-final'));
        return;
      }

       const payload = {
        planId:        this.json.id,
        baseYear:      this.json.baseYear,
        versionnumber: this.plan === 0
          ? (parseInt(this.versionNumber, 10) || 0)
          : this.plan.planData.versionNumber,
        initialDate:   t1,
        finalDate:     t2,
        revision: typeof this.json.revision === 'string'
          ? this.json.revision
          : this.json.revision.toISOString(),
        description:   this.json.description,
        beginWeek:     this.json.beginWeek,
        table:         this.json.table
      };

      defaultSuccess(this.$t('salvando-dados'))
      this.waiting = true;
      const url = `${urlMainAPI}/saveproductionharvestplan`;
      await axios
        .post(url, payload)
        .then((res) => {
          defaultSuccess(res.data);
          this.temp = JSON.parse(JSON.stringify(this.json));
          this.json.revision = new Date(Date.now());
        })
        .catch();
      this.waiting = false;
    },

    reset() {
      this.json = JSON.parse(JSON.stringify(this.temp));
      this.setGrid(this.json.header, this.json.table);
      defaultSuccess(this.$t('alteracoes-descartadas'));
    },

    createGrid() {
      const grid = new cheetahGrid.ListGrid({
        parentElement: document.querySelector(".sample1"),
        allowRangePaste: true,
        header: this.json.header,
      });
      grid.records = this.json.table;
      this.setGrid = function (
        header = this.json.header,
        table = this.json.table,
      ) {
        grid.header = header;
        grid.records = table;
      };
    },

    async GerarExcel() {
      this.loadingReport = true;
      const url = `${urlMainAPI}/getproductionharvestplan/${this.json.id}/${this.json.baseYear}/${this.json.isActive}/true`;
      const response = await this.$http.get(url);
      if (response.data.length == 0) {
        defaultSuccess(this.$t("excel-zerado"));
      } else {
        defaultSuccess("Premissas de Planejamento exportado com sucesso!");
      }
      this.loadingReport = false;
      return response.data.table;
    },

    openModal(actionType) {
      this.actionType = actionType;
      this.isModalVisible = true;

      this.isBase = this.json.isBase
      this.isActive = this.json.isActive
    },

    async confirmAction() {
      try {
        const params = {
          "UserPassword": "Pentabr@0610"
        }
        if (this.password == params["UserPassword"]) {
          const url = `${urlMainAPI}/setproductionplanbaseoractive/${this.json.id}/${this.actionType != 'base' || this.isActive}/${this.actionType === 'base' || this.isBase}`
          await axios
            .get(url)
            .then((res) => {
              defaultSuccess(res.data);
            })
            .catch((error) => {
              showError(error);
            });
          this.loadHarvestPlans();
          this.loadHarvestPlan();
        } else {
          showError(this.$t('senhas-incorreta'));
        }
      } catch (error) {
        showError(error);
      } finally {
        this.isModalVisible = false;
        this.password = '';
      }
    },
  },
  async created() {
    await this.loadHarvestPlan();
    await this.loadHarvestPlans();
  },
  mounted() {
    this.createGrid();
  },
};
</script>

<style scoped>
img {
  height: 38px;
}

.plansInfoContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 1rem;
  position: absolute;
  font-size: 0.9rem;
  top: 1.2rem;
  right: 4rem;
}

.plansInfoContainer section {
  display: flex;
}

.plansInfoContainer section p {
  color: #ff5f00;
  font-weight: bold;
  margin: 0;
  padding-right: 0.5rem;

}

.printer-button {
  position: absolute;
  height: 30px;
  width: 30px;
  cursor: pointer;
  top: 1rem;
  right: 1rem;
}

.gridContent {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 50vh 130px;
  grid-column-gap: 0px;
  grid-row-gap: 0.5rem;
}


.grid {
  height: 100%;
  width: 100%;
  border: solid 1px rgba(0, 0, 0, 0.26);
}

.inputsGroupContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  row-gap: 2rem;
}

.inputsGroupContainer .generalInputs {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 2fr 3fr 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 0px;

  font-size: 1rem;
}

.inputsGroupContainer .generalInputs span {
  font-size: 0.9rem;
}

.inputsGroupContainer .planInputs {
  display: flex;
  align-items: center;
  column-gap: 1rem;
  justify-content: flex-end;
  align-items: flex-end;
}

.planInputs button {
  background-color: #ff5f00;
  color: white;
  border: none;
  border-radius: 0.2rem;
  font-weight: 600;
  padding: 0.4rem 0.3rem;
  cursor: pointer;
}

.dateSelectors {
  display: flex;
  align-items: center;
  column-gap: 1rem;
}

.dateSelectors section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: max-content;
}

.dateSelectors section p {
  margin: 0;
}

label {
  margin: 0;
}

.gridBtGroup {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 1rem;
  justify-content: flex-end;
  padding-right: 1rem;

  justify-self: flex-end;
  align-self: flex-end;
}

.gridBtGroup>img {
  cursor: pointer;
  max-height: 45px;
}

.gridBtGroup span {
  display: inherit;
  column-gap: inherit;


  justify-self: flex-end;
  align-self: flex-end;
}

img {
  cursor: pointer;
}

input {
  width: 100% !important;
}


.button-confirm,
.button-cancel {
  background-color: #4db55d;
  color: white;
}

.button-confirm,
.button-cance {
  width: 90px;
  padding: 5px;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  flex-shrink: 0;
}

.button-cancel {
  background-color: #c82333;
  color: white;
}

.button-confirm:hover {
  background-color: #45a049;
}

.button-cancel:hover {
  background-color: #e53935;
}

.spinnerConfig {
  width: 1.5rem;
  height: 1.5rem;
  color: #ff5f00;
  position: absolute;
  top: 1.2rem;
  right: 3.5rem;
}

.disable-btn,
.disable-btn img {
  filter: grayscale(1);
  pointer-events: none;
  user-select: none;
  cursor: not-allowed;
}

.basePlanBt,
.activePlanBt {
  border-radius: 5%;
  height: 30px;
  width: 140px;
  font-size: small;
}

.definePlanBt {
  display: flex;
  column-gap: 1rem;
  padding-left: 1rem;
}

.definePlanBt button {
  background-color: #ff5f00;
  color: white;
  border: none;
  cursor: pointer;
}

.definePlanBt button:hover {
  background-color: #e05500;
}












/* 


.inputsContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  width: 100%;
  column-gap: 1rem;
}

.rowItem {
  display: flex;
  align-items: center;
  column-gap: 1rem;
  font-size: 15px;
}

.jsonBaseYear {
  height: 35px;
  font-size: small;

}

.description {
  flex: 0 0 200px;
}

.jsonDescription {
  height: 35px;
  font-size: small;
  width: 300px;
}

.adjustDatePickers {
  width: 110px;
  margin: 0 5px 0 5px;
  height: 35px;
  font-size: small;

}

.select-start-week {
  width: 140px;
  height: 35px;
  font-size: small;

}

.dates {
  font-size: 12px;
}

.group {
  justify-content: space-between;
  flex-wrap: wrap;
}




.referenceInfo {
  position: absolute;
  top: 1rem;
  right: 4rem;
  font-size: small;
}

.ref-select {
  position: absolute;
  top: 1rem;
  right: 28rem;
  font-size: small;
}


*/


@media only screen and (min-width: 1900px) {
  .gridContent {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 62vh 130px;
    grid-column-gap: 0px;
    grid-row-gap: 0.5rem;
  }
}
</style>

<style>
.cheetah-grid__tooltip-element__content {
  color: white;
}
</style>